module.exports = __webpack_public_path__ + "static/media/camera-lens-cap5.3549055c.aac";